'use strict';

import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {observer} from "mobx-react";
import classnames from 'classnames';

import {FaSpinner, FaPlusCircle, FaTimesCircle} from "react-icons/fa";

import Button from 'react-bootstrap/Button';

import {States} from '@uw-it-sis/lib-react/lib/AppConstants';
import appStore from '@uw-it-sis/lib-react/lib/AppStore';
import planItemStore from './PlanItemStore';

import {MetricLabels} from "@uw-it-sis/lib-react-myplan/lib/Constants";

/**
 * A toggling add/remove button for sections.
 */
class AddOrRemoveSectionButton extends Component {

    constructor(props) {
        super(props);
        this.props = props;
        this.store = planItemStore;

        this.handleAddToPlanClick = this.handleAddToPlanClick.bind(this);
        this.handleRemoveFromPlanClick = this.handleRemoveFromPlanClick.bind(this);

        this.analyticsStore = appStore.getAnalyticsStore();

        this.additionalAnalytics = this.props.additionalAnalytics && Object.keys(this.props.additionalAnalytics).length
            ? this.props.additionalAnalytics : {};
    }

    handleAddToPlanClick = () => {
        const courseCode = this.props.courseCode;
        const sectionCode = this.props.section.code;
        const code =  `${courseCode} ${sectionCode}`;
        const atpId = this.props.section.atpId;

        planItemStore.add(code, atpId, null, null, true);
        let appContext = "";
        if(this.additionalAnalytics) {
            appContext = this.additionalAnalytics.context;
        }
        const labels = this.analyticsStore.label(MetricLabels.quarter, atpId).add(MetricLabels.appContextName, appContext).get();

        this.analyticsStore.addEvent("Add-Section", labels, {cCode: courseCode, sCode: sectionCode, ...this.additionalAnalytics});
    };

    handleRemoveFromPlanClick = () => {
        const courseCode = this.props.courseCode;
        const sectionCode = this.props.section.code;
        const atpId = this.props.section.atpId;
        const planItemId = this.props.section.planItemId;

        planItemStore.remove(planItemId);
        let appContext = "";
        if(this.additionalAnalytics) {
            appContext = this.additionalAnalytics.context;
        }
        const labels = this.analyticsStore.label(MetricLabels.quarter, atpId).add(MetricLabels.appContextName, appContext).get();
        this.analyticsStore.addEvent("Remove-Section", labels, {cCode: courseCode, sCode: sectionCode, ...this.additionalAnalytics});
    };

    render() {
        let clickHandlerMethod, Icon, isCurrentPendingItem, hoverText;
        let disabled = false;

        // The planItemId if the section is planned. Otherwise, undefined.
        const planItemId = this.props.section.planItemId;
        const pendingActionItem = this.store.actionPendingItem;

        const sectionName = `${this.props.courseCode} ${this.props.section.code}`;

        // If the planItemId is not null, then the section is planned, make button a remove action
        if (planItemId != null) {
            // If the state is pending, disable the click handler for remove action
            clickHandlerMethod = this.store.state !== States.pending ? this.handleRemoveFromPlanClick : null;
            // If the state is pending and the current item is the item in flight, set flag to true
            isCurrentPendingItem = this.store.state === States.pending && pendingActionItem === planItemId;
            // if this is the current item in flight, show spinner to indicate pending state
            Icon = FaTimesCircle;
            hoverText = `Remove ${sectionName} and any planned quizzes, labs, etc.`;
            if (! this.props.section.primary) {
                hoverText = `Remove ${sectionName}`;
            }
        } else {
            // Only allow sections that are active to be added to the plan
            if (this.props.section.stateKey === 'active') {
                // If the state is pending, disable the click handler for add action
                clickHandlerMethod = this.store.state !== States.pending ? this.handleAddToPlanClick : null;
                // If the state is pending and the current item is the item in flight, set flag to true
                const code = this.props.courseCode + " " + this.props.section.code;
                isCurrentPendingItem = this.store.state === States.pending && pendingActionItem === code;
                // if this is the current item in flight, show spinner to indicate pending state
                Icon = FaPlusCircle;
                hoverText = `Select ${sectionName}`;
            } else {
                // When section is not planned and is not active, no action can be taken
                hoverText = `Selecting ${sectionName} is not allowed`;
                Icon = FaPlusCircle;
                isCurrentPendingItem = false;
                disabled = true;
            }
        }

        if (isCurrentPendingItem) {
            Icon = FaSpinner;
        }

        return (
            <Button variant="icon-link"
                    size={this.props.size ?? undefined}
                    className={classnames("px-1", {'text-body': isCurrentPendingItem})}
                    title={hoverText}
                    onClick={isCurrentPendingItem || disabled ? null : clickHandlerMethod}
                    disabled={disabled}>
                <Icon
                    className={classnames({"icon-spin": isCurrentPendingItem})}
                    aria-hidden={true} />
            </Button>
        );
    }
}

AddOrRemoveSectionButton.propTypes = {
    courseCode: PropTypes.string.isRequired,
    section: PropTypes.object.isRequired,
    additionalAnalytics: PropTypes.object,
    size: PropTypes.string
};

AddOrRemoveSectionButton.defaultProps = {
    size: null
};

export default observer(AddOrRemoveSectionButton);
